export const validate = (inputs) => {

    const errors = {};

    return errors;
}